import AccentButton from '@components/ui/AccentButton';
import { Paper, Typography } from '@material-ui/core';

const ComplementaryServiceCard = ({
  title,
  description,
  buttonText,
  buttonLink,
  iconSrc,
  iconAlt,
  disabled = false,
}) => {
  return (
    <Paper
      className="p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl h-full rounded-lg !bg-[#f8f8f8] flex flex-col"
      elevation={0}
      style={{ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }}
    >
      {iconSrc && (
        <div className="mb-4 flex justify-center">
          <img src={iconSrc} alt={iconAlt || title} className="w-16 h-16 object-contain" />
        </div>
      )}
      <div className="flex flex-col flex-grow text-center">
        <Typography
          variant="h5"
          component="h3"
          className="mb-3 text-stone-800"
          style={{ fontWeight: 700 }}
        >
          {title}
        </Typography>
        <Typography variant="body2" className="mb-6 text-stone-600 leading-relaxed flex-grow">
          {description}
        </Typography>
        <div className="mt-auto">
          <AccentButton
            to={disabled ? undefined : buttonLink}
            variant="contained"
            size="medium"
            disabled={disabled}
          >
            {buttonText}
          </AccentButton>
        </div>
      </div>
    </Paper>
  );
};

export default ComplementaryServiceCard;
